import React, { useEffect } from "react";

import { navigation } from "@origin-digital/reporting-client";
import {
  Button,
  Card,
  CardStackSection,
  Heading,
  MarkdownLite,
  Stack,
  Text,
} from "@origin-digital/ods-core";

import { Construction } from "./Construction";
import content from "./content.json";

export const UnderConstruction = () => {
  useEffect(() => {
    const { href, pathname } = window.location;
    navigation("screen", {
      currentUri: href,
      path: pathname,
    });
  }, []);

  return (
    <CardStackSection data-id="under-construction">
      <Card padding="medium">
        <Stack alignX="center" space={["large", "xlarge"]}>
          <Construction />

          <Stack alignX="center" space={["medium", "large"]}>
            <Heading align="center" variant="h4">
              {content.heading}
            </Heading>

            <Text align="center">{content.text}</Text>
          </Stack>

          <Button
            variant="outlined"
            data-id="call-to-action"
            href={content.cta.href}
          >
            {content.cta.text}
          </Button>

          <Text variant="body-small" tone="neutralLight" align="center">
            <MarkdownLite>{content.disclaimer}</MarkdownLite>
          </Text>
        </Stack>
      </Card>
    </CardStackSection>
  );
};
